module.exports = __webpack_public_path__ + "static/media/terre-d-hermes.2e671849.png";